import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { dictionary } from '../lang';
import { settings } from '../settings';
import { mergeClassNames, urlTo } from '../utils';
const Layout = ({ title, children, }) => {
    const { pathname } = useLocation();
    const menuItems = useMemo(() => ([
        {
            label: dictionary.VIEW_AREAS,
            path: urlTo('areas'),
            isActive: !!pathname.match(new RegExp(`${settings.routePrefix}(/area(s|/.*)|$)`)),
        },
        {
            label: dictionary.VIEW_TEAMS,
            path: urlTo('teams'),
            isActive: !!pathname.match(new RegExp(`${settings.routePrefix}/team(s|/.*)`)),
        },
    ]), [pathname]);
    return (_jsxs("div", { className: "container grow flex flex-col pb-6 text-gray-600", children: [_jsx("div", { className: "pt-4.5 pb-3", children: _jsx("h1", { className: "text-[2rem]/10 text-gray-900", children: title }) }), _jsxs("div", { className: "grow grid grid-cols-4 gap-4 2xl:gap-6", children: [_jsx("aside", { className: "col-span-1 border rounded-lg p-6 bg-white", children: _jsx("nav", { "aria-label": "Side Navigation", children: _jsx("ul", { className: "-mx-6", children: menuItems.map((item) => (_jsx("li", { children: _jsx(Link, { to: item.path, className: mergeClassNames('block py-2 px-6 text-sm text-gray-900', 'hover:bg-gray-50 hover:text-primary-300', { 'text-primary-300': item.isActive }), children: item.label }) }, item.path))) }) }) }), _jsx("div", { className: "col-span-3", children: children })] })] }));
};
export default Layout;
